<app-top-navigation></app-top-navigation>

<section class="home-bg carosell-wrapper">



    <div class="container">
        <div class="centered-element text-center">
            <div class="row">
                <div class="medium-12 columns">
                    <div class="large-text gotham">
                        DJI INDONESIA
                    </div>
                    <div class="mega-text margin-bottom-2 uppercase gotham">
                        DJI Authorized Dealer
                    </div>
                    <button class="button small margin-right-05">
                        Pesan Online
                    </button>
                    <button routerLink="/location" class="button small clear hollow">
                        Lihat Lokasi
                    </button>

                </div>
            </div>
        </div>
    </div>


    <div class="carosell-navigation hide">
        <a style="
    color: white;" class="carosell-navigation-left">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
        </a>
        <a style=" 
    color: white;" class="carosell-navigation-right">
            <fa-icon [icon]="faChevronRight"></fa-icon>
        </a>
    </div>
</section>


<section class="category-section padding-center show-for-medium">
    <div class="row">
        <div class="medium-12 columns text-center color-black">
            <div class="row medium-up-2">
                <div (click)="navigateTo(item)" *ngFor="let item of prosummer" class="columns margin-bottom-1">
                    <div class="image-container">
                        <img class="cover_image" [src]="item.img" alt="">
                        <div class="image-content">
                            <div class="title gotham uppercase">
                                {{item.title}}
                            </div>
                            <!-- <div class="description margin-bottom-1">
                                {{item.desc}}
                            </div> -->
                            <div class="cta">
                                Learn More <fa-icon [icon]="faChevronRight"></fa-icon>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>
</section>

<div class="padding-center show-for-small-only">
    <div class="mega-text text-center gotham uppercase margin-bottom-1 color-black">
        Prosumer Drone
    </div>
    <div style="padding-left: 1rem;" class="flex-container scroll-container color-black ">

        <div *ngFor="let item of prosummer" class="flex-item" style="flex: 0 0 45%;margin-right: 0.5rem;">
            <div (click)="navigateTo(item)" class="image-container color-black ">
                <img style="object-fit: cover;height: 200px;height: 240px;" [src]="item.img" alt="">
                <div class="image-content">
                    <div class="title gotham">
                        {{item.title}}
                    </div>

                    <div class="cta">
                        Learn More <fa-icon [icon]="faChevronRight"></fa-icon>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<app-section-gallery></app-section-gallery>

<section class="padding-center text-center">
    <div class="mega-text margin-bottom-1  color-black">
        <div class="huge-text">
            DJI Enterprise & Business Order
        </div>
        <div class="mega-text bold gotham">
          Lihat Solusi Untuk <br>Berbagai Sektor Industri
        </div>

    </div>
    <div class="margin-bottom-2 show-for-medium">
        <div class="row medium-up-3">
            <div *ngFor="let item of enterprise" class="columns">
                <div (click)="navigateTo(item)" class="image-container">
                    <img [src]="item.img" alt="">
                    <div class="image-content">
                        <div class="title gotham">
                           {{item.title}}
                        </div>
                        <div class="desctiption margin-bottom-1">
                            {{item.desc}}
                        </div>
                        <div class="cta">
                            Learn More <fa-icon [icon]="faChevronRight"></fa-icon>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>


    <div style="padding-left: 1rem;" class="flex-container scroll-container color-black show-for-small-only">

        <div *ngFor="let item of enterprise" class="flex-item" style="flex: 0 0 45%;margin-right: 0.5rem;">
            <div (click)="navigateTo(item)" class="image-container white">
                <img [src]="item.img" alt="">
                <div class="image-content">
                    <div class="title gotham">
                        {{item.title}}
                    </div>

                    <div class="cta">
                        Learn More <fa-icon [icon]="faChevronRight"></fa-icon>
                    </div>
                </div>
            </div>
        </div>

    </div>

</section>


<app-section-footer></app-section-footer>